import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, Scroll } from '@angular/router';
import { I18nModule, UrlModule } from 'haba-core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { GlobalMessageCustomComponent } from '../../features/misc/global-message/global-message.component';
import { MessagesService } from '@app/services';
import { CheckoutProgressComponent } from './checkout-progress/checkout-progress.component';
import { SvgComponent } from '@app/base-components';

@Component({
  selector: 'app-checkout-header',
  templateUrl: './checkout-header.component.html',
  styleUrls: ['./checkout-header.component.scss'],
  imports: [
    NgClass,
    RouterLink,
    NgIf,
    NgFor,
    CheckoutProgressComponent,
    GlobalMessageCustomComponent,
    UrlModule,
    SvgComponent,
    I18nModule,
  ],
})
export class CheckoutHeaderComponent implements OnInit, OnDestroy {
  public infobarTexts = [
    { text: 'habaCheckoutInforbarText.freeReturn' },
    { text: 'habaCheckoutInforbarText.noMinimumOrderValue' },
    { text: 'habaCheckoutInforbarText.carefullyTestedProducts' },
    { text: 'habaCheckoutInforbarText.sparePartService' },
  ];
  public smallHeader: boolean = false;
  public isCheckoutLogin: boolean = false;

  private urlCheckoutPatterns = ['/authorize-payment'];
  private urlCheckoutLoginPatterns = ['/checkout-login'];
  private sub: Subscription = new Subscription();

  constructor(
    private router: Router,
    private messagesService: MessagesService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.sub.add(
      this.router.events
        .pipe(filter((event: Scroll) => event.routerEvent instanceof NavigationEnd))
        .subscribe(() => {
          this.smallHeader = !!this.urlCheckoutPatterns.find((pattern) =>
            this.router.url.includes(pattern)
          );
          this.isCheckoutLogin = !!this.urlCheckoutLoginPatterns.find((pattern) =>
            this.router.url.includes(pattern)
          );
          this.messagesService.showExternalMessages(this.activatedRoute.snapshot.queryParams);
        })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
